(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.tosChristmasOffer = api;
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  const excluded = new Set([9538801107175,9691189903591,9709455212775,9709116784871,9697718993127,9623414800615,9625434161383,9628652273895,9679382675687,9719024713959]);
  function campaignActive(now) { return now >= 1793588400000 && now < 1795748399000; }
  function summarize(snapshot, decimals) {
    const metadata = new Map(snapshot.lines.map(line => [line.key, line]));
    const eligible = snapshot.cart.items.filter(item => metadata.get(item.key)?.eligible && item.original_line_price > 0 && item.quantity > 0);
    const count = eligible.reduce((sum, item) => sum + item.quantity, 0);
    const original = eligible.reduce((sum, item) => sum + item.original_line_price, 0);
    const allocation = item => (metadata.get(item.key)?.allocations || []).filter(a => String(a.discount_application?.title).trim().toUpperCase() === 'LOTR15').reduce((sum,a) => sum + Number(a.amount || 0),0);
    const applied = count >= 3 && eligible.length > 0 && eligible.every(item => allocation(item) > 0);
    const actualSavings = eligible.reduce((sum, item) => sum + allocation(item), 0);
    const factor = 10 ** decimals;
    const estimate = Math.round(Math.round(original / 100 * 0.85 * factor) / factor * 100);
    const otherDiscount = eligible.some(item => item.final_line_price < item.original_line_price) && !applied;
    return {count, missing: Math.max(0,3-count), original, applied, eligible,
      discounted: applied ? original - actualSavings : estimate,
      savings: applied ? actualSavings : original - estimate,
      showEstimate: count > 0 && count < 3 && !otherDiscount,
      pending: count >= 3 && !applied};
  }
  function owned(items, id, token) {
    return items.find(item => Number(item.product_id) === Number(id) && item.properties?._tos_bundle === token);
  }
  function choose(pool, items, selected, current, rotate = false) {
    const inCart = new Set(items.map(item => Number(item.product_id)));
    const kept = new Set(selected.map(Number));
    const previous = new Set(current.map(Number));
    const result = [];
    const groups = new Set(pool.filter(p => inCart.has(Number(p.product_id)) && !kept.has(Number(p.product_id))).map(p => p.group).filter(Boolean));
    const candidates = [
      ...pool.filter(p => kept.has(Number(p.product_id))),
      ...pool.filter(p => !kept.has(Number(p.product_id)) && (rotate ? !previous.has(Number(p.product_id)) : previous.has(Number(p.product_id)))),
      ...pool.filter(p => !kept.has(Number(p.product_id)) && (rotate ? previous.has(Number(p.product_id)) : !previous.has(Number(p.product_id))))
    ];
    for (const p of candidates) {
      const id = Number(p.product_id);
      if (result.length === 3) break;
      if (result.some(x => Number(x.product_id) === id)) continue;
      if (!kept.has(id) && (!p.available || !p.eligible || inCart.has(id))) continue;
      if (p.group && groups.has(p.group)) continue;
      result.push(p); if(p.group) groups.add(p.group);
    }
    return result;
  }
  return {blocked: id => excluded.has(Number(id)) || !Number(id), summarize, campaignActive, choose, owned};
});
